import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=4a653ebc&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a653ebc')) {
      api.createRecord('4a653ebc', component.options)
    } else {
      api.reload('4a653ebc', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=4a653ebc&", function () {
      api.rerender('4a653ebc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20obWn0Xya0Tn/JS/comp/ImgFallback.vue"
export default component.exports